import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { StatementsFacade } from '@app/modules/statements/services/statements.facade';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { LocalStorageKey } from '@app/shared/interfaces';
import { getDataWithExpiry } from '@app/shared/utils/lib/cache.util';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DialogPublishData {
  statementId: string;
}

@Component({
  standalone: false,
  selector: 'sbnb-dialog-publish',
  templateUrl: './dialog-publish.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogPublishComponent implements OnInit {
  public limitedPreview$ = this.upsellService.ownerStatementLimitedPreview$;
  public isPrimaryUser$ = this.userPermissionsService.isPrimaryUser();
  private statement$ = this.statementsFacade.getStatementDetail(Number(this.data.statementId));
  private accountingEnabled$ = this.upsellService.accountingEnabled$;
  private accountingConnectionEnabled$ = this.statementsFacade.connectionsState$.pipe(
    map((state) => state.data?.find((connection) => connection.enabled))
  );

  public viewModel$ = combineLatest([this.statement$, this.accountingConnectionEnabled$, this.accountingEnabled$]).pipe(
    map(([statement, hasAccountingConnection, isAccountingEntitlementEnabled]) => {
      const upsellDismissed = getDataWithExpiry(LocalStorageKey.QuickbooksUpsellDismissed);
      const data = {
        isInvoice: statement.type === 'invoice',
        accountingEnabled: isAccountingEntitlementEnabled && hasAccountingConnection,
        accountingConnectionUpsell: isAccountingEntitlementEnabled && !hasAccountingConnection && !upsellDismissed,
        type: statement.type,
      };
      return data;
    })
  );

  public quickbooksNotRightNow = false;

  constructor(
    public dialogRef: MatDialogRef<DialogPublishComponent>,
    private upsellService: UpsellService,
    private userPermissionsService: UserPermissionsService,
    private statementsFacade: StatementsFacade,
    @Inject(MAT_DIALOG_DATA) public data: DialogPublishData
  ) {}

  ngOnInit(): void {
    this.statementsFacade.listConnections();
  }

  onConnectQuickbooks(): void {
    this.dialogRef.close('connect-quickbooks');
  }

  onDismissQuickbooksUpsell(): void {
    // Set expiry to 3 months from now
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 3);

    localStorage.setItem(
      LocalStorageKey.QuickbooksUpsellDismissed,
      JSON.stringify({
        data: true,
        expiresAt: expiryDate.getTime(),
      })
    );

    this.quickbooksNotRightNow = true;
  }
}
